import { useState, useEffect } from 'react'

interface ScrollContextTypes {
  scrollX: number
  scrollY: number
}

const defaultScrollState = {
  scrollX: 0,
  scrollY: 0,
}

const useScrollListenerHook = (): ScrollContextTypes => {
  const [scrollValues, setScrollValues] =
    useState<ScrollContextTypes>(defaultScrollState)

  useEffect(() => {
    const getScrollValues = () => {
      const { scrollX, scrollY } = window
      setScrollValues({ scrollX: scrollX, scrollY: scrollY })
    }

    window.addEventListener('scroll', getScrollValues)

    return () => {
      window.addEventListener('scroll', getScrollValues)
    }
  }, [])

  return scrollValues
}

export default useScrollListenerHook
